module.exports = __webpack_public_path__ + "static/img/666.30ee212.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s32/pop/666.png
// module id = TDgL
// module chunks = 2